import { reaction } from "mobx";


export default function() {
  this.reactions=[];

  this.addReaction=(callback1, callback2, opts={})=>{
    this.reactions.push(reaction(callback1, callback2, opts));
  }
  this.clear=()=> {
    for (let i in this.reactions) {
      this.reactions[i]();
    }
  }
}